import moment from 'moment';
import {
  ExpenseGoalDTO,
  LargePurchaseGoalDTO,
  NonFinancialGoalDTO,
  SavedGoalDTO,
  SavedGoalType,
} from '../../api/useGoalQuery';
import { FinancialGoalType, WizardState } from '../context/SetGoalProvider';
import { ISO_8601_FORMAT } from '../../../AccountPerformanceReporting/helpers/dates';
import { AT_RETIREMENT, STARTS_TODAY } from './getDisplayDate';

export const dataToWizard = (data: SavedGoalDTO): Partial<WizardState> => {
  if (data.GoalType === SavedGoalType.LargePurchase) {
    const {
      Name,
      Amount,
      Inflation,
      IsRecurringPurchase,
      OneTimeOptions,
      RecurringOptions,
      Accounts,
    } = data.GoalData as LargePurchaseGoalDTO;

    return {
      isFinancialGoal: true,
      goalDescription: Name,
      goalType: FinancialGoalType.LargePurchase,
      purchase: {
        amount: Amount,
        inflation: Inflation,
        isRecurringPurchase: IsRecurringPurchase,
        ...(!IsRecurringPurchase && OneTimeOptions
          ? {
              oneTimeOptions: {
                isAtRetirement: OneTimeOptions.IsAtRetirement,
                targetYear: OneTimeOptions.IsAtRetirement
                  ? AT_RETIREMENT
                  : OneTimeOptions.TargetYear,
              },
            }
          : {}),
        ...(IsRecurringPurchase && RecurringOptions
          ? {
              recurringOptions: {
                isAtRetirement: RecurringOptions.IsAtRetirement,
                startYear: RecurringOptions.IsAtRetirement
                  ? AT_RETIREMENT
                  : RecurringOptions.StartYear,
                repeatEvery: RecurringOptions.RepeatEvery,
                repeatFor: RecurringOptions.RepeatFor,
              },
            }
          : {}),
      },
      accountIds: Accounts,
    };
  }

  if (data.GoalType === SavedGoalType.Expense) {
    const {
      Name,
      Amount,
      StartDate,
      SaveEvery,
      SaveForLength,
      SaveForPeriod,
    } = data.GoalData as ExpenseGoalDTO;

    const isStartDateToday =
      moment().format(ISO_8601_FORMAT) === moment(StartDate).format(ISO_8601_FORMAT);

    return {
      isFinancialGoal: true,
      goalDescription: Name,
      goalType: FinancialGoalType.Expense,
      expense: {
        amount: Amount,
        startDate: isStartDateToday ? STARTS_TODAY : moment(StartDate).year(),
        saveEvery: SaveEvery,
        saveForLength: SaveForLength,
        saveForPeriod: SaveForPeriod,
      },
    };
  }

  const { Name, TargetDate } = data.GoalData as NonFinancialGoalDTO;

  return {
    isFinancialGoal: false,
    goalDescription: Name,
    targetDate: TargetDate,
  };
};
